import { render, staticRenderFns } from "./PromotionSequenceForm.vue?vue&type=template&id=00a48712&"
import script from "./PromotionSequenceForm.vue?vue&type=script&lang=js&"
export * from "./PromotionSequenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports